// extracted by mini-css-extract-plugin
export var copyableField = "_nl-4";
export var customerBadge = "_nl-0";
export var customerInfoTitle = "_nl-2";
export var details = "_nl-1";
export var dropdownContainer = "_nl-5";
export var dropdownImage = "_nl-6";
export var editAssigneeForm = "_nl-a";
export var editButton = "_nl-3";
export var email = "_nl-7";
export var hidden = "_nl-d";
export var input = "_nl-8";
export var saveButton = "_nl-b";
export var shopifyIcon = "_nl-c";
export var suggestionBadge = "_nl-e";
export var suggestionText = "_nl-f";
export var username = "_nl-9";